import React from 'react';
import AssignmentReturned from '@material-ui/icons/AssignmentReturnedOutlined';
import TextWithIcon from '../../../../../components/Input/TextWithIcon';

export default ({actualsSubmittedBy}) => {
    return (<div style={{position: 'relative'}}>
                <TextWithIcon label="Actuals submitted by" value={actualsSubmittedBy} icon={AssignmentReturned}/>
            </div>)
}